import { Component, computed, forwardRef, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxIconBoxComponent,
  OnyxIconButtonComponent,
  OnyxIconComponent,
  OnyxInformationHeadingComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import { RouteComponent } from '../../../../../common/components/route/route.component';
import { RouteService } from '../../../../../common/services/route.service';
import { OrdersQueryParamKey } from '../../../common/enums/orders-query-param-key';
import { OrderHelper } from '../../../common/helpers/order.helper';
import type { Order } from '../../../common/interfaces/order';

@Component({
  selector: 'app-order-modal-route',
  imports: [
    TranslatePipe,
    OnyxTooltipDirective,
    OnyxIconComponent,
    forwardRef(() => RouteComponent),
    OnyxIconButtonComponent,
    OnyxIconBoxComponent,
    OnyxInformationHeadingComponent,
  ],
  templateUrl: './order-modal-route.component.html',
  styleUrl: './order-modal-route.component.scss',
})
export class OrderModalRouteComponent {
  private readonly routeService = inject(RouteService);
  private readonly orderHelper = inject(OrderHelper);

  public readonly order = input.required<Order>();
  public readonly close$ = input.required<Subject<void>>();

  protected readonly I18N = 'orders.ordersList.cells';

  protected isExpanded = this.routeService.isRouteExpanded;
  protected planRouteState = computed(() =>
    this.orderHelper.getPlanRouteState(this.order()),
  );

  protected toggleExpanded(): void {
    this.routeService.toggleRouteExpanded();
  }

  protected planRoute(): void {
    this.orderHelper.edit(this.order().uuid, {
      options: { close$: this.close$() },
      params: { [OrdersQueryParamKey.PLAN_ROUTE]: true },
    });
  }
}
